import React from "react";
import {
  FunnelChart,
  Funnel,
  LabelList,
  ResponsiveContainer
} from "recharts";
import "../App.css";


export default function ConversionFunnel({ data, variant = "chart" }) {
  if (!Array.isArray(data) || data.length === 0) return null;

  if (variant === "journey") {
    return <ConversionJourney data={data} />;
  }

  return (
    <ResponsiveContainer width="100%" height={320}>
      <FunnelChart>
        <Funnel dataKey="value" data={data} isAnimationActive>
          {/* Title + Value */}
          <LabelList content={(props) => MainLabel(props, data)} />

          {/* Percentage Arrow */}
          <LabelList content={(props) => ArrowLabel(props, data)} />
        </Funnel>
      </FunnelChart>
    </ResponsiveContainer>
  );
}

function ConversionJourney({ data }) {
  return (
    <div className="conversion-journey" aria-label="Conversion journey">
      {data.map((item, index) => {
        const nextItem = data[index + 1];
        const conversion = item.actual ? ((nextItem?.actual || 0) / item.actual) * 100 : 0;

        return (
          <React.Fragment key={item.label}>
            <div className="conversion-journey__step" style={{ "--step-color": item.fill }}>
              <div className="conversion-journey__marker">{String(index + 1).padStart(2, "0")}</div>
              <div className="conversion-journey__details">
                <span>{item.label}</span>
                <strong>{Number(item.actual || 0).toLocaleString()}</strong>
              </div>
              <div className="conversion-journey__share">
                <span>of menu opens</span>
                <strong>{data[0]?.actual ? `${((item.actual / data[0].actual) * 100).toFixed(1)}%` : "0%"}</strong>
              </div>
            </div>

            {nextItem && (
              <div className="conversion-journey__connector">
                <span />
                <b>{conversion.toFixed(1)}% continue</b>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

/* ================= MAIN LABEL ================= */
function MainLabel({ x, y, width, height, index }, data) {
  const item = data[index];
  if (!item) return null;

  const actualValue =
    typeof item.actual === "number" ? item.actual : 0;

  return (
    <g>
      <text
        x={x + width / 2}
        y={y + height / 2 - 6}
        textAnchor="middle"
        fill="#ffffff"
        fontSize="13"
        fontWeight="600"
      >
        {item.label}
      </text>

      <text
        x={x + width / 2}
        y={y + height / 2 + 10}
        textAnchor="middle"
        fill="#E5E7EB"
        fontSize="12"
      >
        {actualValue.toLocaleString()}
      </text>
    </g>
  );
}

/* ================= ARROW + % ================= */
function ArrowLabel({ x, y, width, height, index }, data) {
  if (index >= data.length - 1) return null;

  const current = data[index]?.actual ?? 0;
  const next = data[index + 1]?.actual ?? 0;

  if (current === 0) return null;

  const percent = ((next / current) * 100).toFixed(1);
  const bad = percent < 40;

  return (
    <g>
      <text
        x={x + width / 2}
        y={y + height - 10}
        textAnchor="middle"
        fill={bad ? "#FCA5A5" : "#BBF7D0"}
        fontSize="12"
        fontWeight="700"
      >
        ↓ {percent}%
      </text>
    </g>
  );
}
